<div
  [bfx-input]="bfxInput"
  [ngClass]="inputDirective.classes"
  #input
  [bfxTooltip]="data.errorMsg ? data.errorMsg : null"
  tooltipPosition="top"
  tooltipStyleClass="bfx-tooltip-negative-bold"
  class="icd__checkbox__container"
>
  <div class="bfx-input-label">
    <p-checkbox
      [binary]="true"
      [disabled]="disabled || data.disabled || locked"
      [bfxInputLabelOnClick]="chkBoxLabel"
      [(ngModel)]="data.boolValue"
      (onChange)="onValueChange()"
      [ngClass]="{
          'icd__base__checkbox': true,
          'bfx-checkbox-subtle-sm': true,
          'bfx-checkbox-subtle-invalid': data.errorMsg,
          'icd__base__checkbox--checked-active': data.boolValue && !data.disabled && !locked && !disabled,
          'icd__base__checkbox--checked-disabled': data.boolValue && data.disabled && !locked && !disabled,
          'icd__base__checkbox--unchecked-active': !data.boolValue && !data.disabled && !locked && !disabled,
          'icd__base__checkbox--unchecked-disabled': !data.boolValue && data.disabled && !locked && !disabled,
          'icd__base__checkbox--locked': disabled || locked || data.disabled
        }"
    >
    </p-checkbox>
    <div
      [ngClass]="inputDirective.labelClasses"
      [class.bfx-checkbox-label-invalid-subtle]="data.errorMsg"
      #chkBoxLabel
    >
      {{label}}<!-- <span *ngIf="required">*</span> -->
    </div>
  </div>
  <!-- <div [ngClass]="inputDirective.innerClasses"></div> -->
</div>
